export const HazardLevelTranslated = {
  Acceptable: "Aceitável",
  Low: "Baixo",
  Moderate: "Moderado",
  Significant: "Significativo",
  High: "Alto",
  VeryHigh: "Muito Alto",
  Extreme: "Extremo",
};

export const HazardLevel = {
  Acceptable: "acceptable",
  Low: "low",
  Moderate: "moderate",
  Significant: "significant",
  High: "high",
  VeryHigh: "very_high",
  Extreme: "extreme",
};
